// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsRemoteCollections from '@/app/modules/remoteCollections/api/actionsRemoteCollections';
// Components
import ModalSendMail from '@/common-utils/components/renders/modal/components/modals/ModalSendMail';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import { DateTime } from 'luxon';
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsRemoteCollection } from '@/app/i18n/namespaces';


/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.type
 * @param root0.transaction
 * @returns {JSX} ModalSendMail
*/
function ModalSendTransactionByMail({ isOpen, setIsOpen, transaction }) {

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);

    // Constants
    const MAX_EMAILS_TO_SEND = 5;

    // State
    const [renderList, setRenderList] = useState([{ email: '', isValid: true }]);

    // Toast
    const { toast } = useToast();

    // Api calls
    const onSuccess = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.send_by_mail.success' namespace={nsRemoteCollection} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.send_by_mail.UNKNOWN_ERROR' namespace={nsRemoteCollection} />,
            variant: 'danger'
        });
    };
    const sendTransactionByMail = actionsRemoteCollections.sendTransactionByMail(onSuccess, onError);

    return (
        <ModalSendMail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            onValidate={() => {
                sendTransactionByMail.mutate({
                    transactionId: transaction.uuid,
                    provider: rootOrganization.uuid,
                    emails: renderList.map(user => user.email)
                });
            }}
            isLoading={sendTransactionByMail.isLoading}
            header={{ title: 'modal.send_by_mail.title.transaction', namespace: nsRemoteCollection }}
            message={{
                entity: 'modal.send_by_mail.message.transaction', namespace: nsRemoteCollection,
                data: {
                    contract: transaction.contract,
                    application: transaction.application,
                    reconciliationNumber: transaction.reconciliationNumber,
                    localTransactionDate: DateTime.fromISO(transaction.localTransactionDateTime).toLocaleString(DateTime.DATE_SHORT),
                    localTransactionTime: DateTime.fromISO(transaction.localTransactionDateTime).toLocaleString(DateTime.TIME_SIMPLE)
                }
            }}
            confirm={{ entity: `modal.send_by_mail.confirm.${renderList.length > 1 ? 'multiple' : 'single'}`, namespace: nsRemoteCollection }}
            renderList={renderList}
            setRenderList={setRenderList}
            maxEmailsNumber={MAX_EMAILS_TO_SEND}
        />
    );
}

ModalSendTransactionByMail.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    transaction: PropTypes.object.isRequired
};

export default ModalSendTransactionByMail;